"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uploads = undefined;

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

var _union = require("lodash/union");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
// For saved for later success just update status to saved and dispatch event in under review compoent to fire call to get new active
//
var uploads = exports.uploads = function uploads() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var arrays = {},
        upload = {},
        uploads = {},
        nextState = {};

    switch (action.type) {
        case actionTypes.FETCH_NEW_UPLOADS_SUCCESS:
            arrays = {
                union: ["keys"],
                replace: ["counts"]
            };

            if (action.page === 1) {
                // if first page, replace all arrays with new data - no union merge
                arrays.replace = arrays.replace.concat(arrays.union.splice(0));
            }

            uploads = action.response;
            if (state.keys) {
                if (state.keys.length > 0) {
                    uploads.keys.forEach(function (uploadId) {
                        nextState = mergeEntity("uploads", uploadId, state, uploads, arrays);
                    });
                } else {
                    nextState = Object.assign({}, state, uploads);
                }
            } else {
                nextState = Object.assign({}, state, uploads);
            }
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.FETCH_SAVED_UPLOADS_SUCCESS:
            arrays = {
                union: ["keys"],
                replace: ["counts"]
            };

            if (action.page === 1) {
                // if first page, replace all arrays with new data - no union merge
                arrays.replace = arrays.replace.concat(arrays.union.splice(0));
            }

            uploads = action.response;
            if (state.keys) {
                if (state.keys.length > 0) {
                    uploads.keys.forEach(function (uploadId) {
                        nextState = mergeEntity("uploads", uploadId, state, uploads, arrays);
                    });
                } else {
                    nextState = Object.assign({}, state, uploads);
                }
            } else {
                nextState = Object.assign({}, state, uploads);
            }
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.FETCH_SUSPENDED_UPLOADS_SUCCESS:
            arrays = {
                union: ["keys"],
                replace: ["counts"]
            };

            if (action.page === 1) {
                // if first page, replace all arrays with new data - no union merge
                arrays.replace = arrays.replace.concat(arrays.union.splice(0));
            }

            uploads = action.response;
            if (state.keys) {
                if (state.keys.length > 0) {
                    uploads.keys.forEach(function (uploadId) {
                        nextState = mergeEntity("uploads", uploadId, state, uploads, arrays);
                    });
                } else {
                    nextState = Object.assign({}, state, uploads);
                }
            } else {
                nextState = Object.assign({}, state, uploads);
            }
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SEARCH_UPLOADS_SUCCESS:
            nextState = action.response;
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SEARCH_SAVED_UPLOADS_SUCCESS:
            nextState = action.response;
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SEARCH_SUSPENDED_UPLOADS_SUCCESS:
            nextState = action.response;
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.FETCH_UPLOAD_ICONS_SUCCESS:
            arrays = {
                union: ["keys", "iconKeys"],
                replace: ["counts"]
            };

            uploads = action.response;

            uploads.keys.forEach(function (uploadId) {
                state.error = false;
                if (state[uploadId] && uploads[uploadId].status === "active") {
                    uploads[uploadId].iconKeys.forEach(function (iconId) {
                        if (state[uploadId].icons) {
                            if (state[uploadId].icons[iconId]) {
                                uploads[uploadId].icons[iconId].name = state[uploadId].icons[iconId].name;
                                uploads[uploadId].icons[iconId].tags = state[uploadId].icons[iconId].tags;
                            }
                        }
                    });
                    uploads[uploadId].icons = mergeEntity("uploads", uploadId, state[uploadId].icons, uploads[uploadId].icons, arrays);
                    uploads[uploadId] = mergeEntity("uploads", uploadId, state[uploadId], uploads[uploadId], arrays);
                    nextState = Object.assign({}, state, uploads);
                } else {
                    nextState = mergeEntity("uploads", uploadId, state, uploads, arrays);
                }
            });
            return nextState;

            break;

        case actionTypes.PREVIEW_UPLOAD_ICONS_SUCCESS:
            arrays = {
                union: ["keys", "iconKeys"],
                replace: ["counts"]
            };

            upload = action.response;

            upload.keys.forEach(function (uploadId) {
                upload[uploadId].status = "preview";

                if (state[uploadId]) {
                    upload[uploadId].icons = mergeEntity("upload", uploadId, state[uploadId].icons, upload[uploadId].icons, arrays);
                    upload[uploadId] = mergeEntity("uploads", uploadId, state[uploadId], upload[uploadId], arrays);
                    nextState = Object.assign({}, state, upload);
                } else {
                    nextState = mergeEntity("uploads", uploadId, state, upload, arrays);
                }
            });

            return nextState;

            break;

        case actionTypes.FETCH_UPLOAD_ICONS_FAILURE:
            nextState = Object.assign({}, state);
            nextState.error = true;
            return nextState;

            break;
        case actionTypes.COMPLETE_UPLOAD_FAILURE:
            nextState = Object.assign({}, state);
            nextState.error = true;
            return nextState;
            break;

        case actionTypes.REVIEW_UPLOAD_SUCCESS:
            uploads = Object.assign({}, state);
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                state[uploadId].status = "complete";
            }));
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SAVE_UPLOAD_FOR_LATER_SUCCESS:
            uploads = action.response;
            uploads.keys.forEach(function (uploadId) {
                nextState = Object.assign({}, state, uploads);
            });
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.COMPLETE_UPLOAD_SUCCESS:
            uploads = action.response;
            uploads.keys.forEach(function (uploadId) {
                nextState = Object.assign({}, state, uploads);
            });
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SAVE_CREATOR_NOTE_SUCCESS:
            if (state.keys) {
                nextState = JSON.parse(JSON.stringify(state));
                state.keys.forEach(function (uploadId) {
                    var upload = nextState[uploadId];
                    if (upload.creator.id === action.response.user.id) {
                        upload.creator.notes = action.response.user.creator_info.notes;
                        if (action.response.user.creator_info.important_note === 0) {
                            upload.creator.important_note = false;
                        } else {
                            upload.creator.important_note = true;
                        }
                    }
                });
            }
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SELECT_ICON:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                if (state[uploadId].status === "active") {
                    state[uploadId].icons[action.icon_upload_id].selected = true;
                }
            }));
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.DESELECT_ICON:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                if (state[uploadId].status === "active") {
                    state[uploadId].icons[action.icon_upload_id].selected = false;
                }
            }));
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.FEATURE_ICON:
            if (state.keys) {
                nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                    if (state[uploadId].status === "active") {
                        state[uploadId].icons[action.icon_upload_id].feature_icon = true;
                    }
                }));
            }
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.UNFEATURE_ICON:
            if (state.keys) {
                nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                    if (state[uploadId].status === "active") {
                        state[uploadId].icons[action.icon_upload_id].feature_icon = false;
                    }
                }));
            }
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SELECT_ALL_ICONS:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                if (state[uploadId].status === "active") {
                    state[uploadId].iconKeys.forEach(function (iconId) {
                        if (state[uploadId].icons[iconId].status === null) {
                            state[uploadId].icons[iconId].selected = true;
                        }
                    });
                }
            }));
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.UNSELECT_ALL_ICONS:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                if (state[uploadId].status === "active") {
                    state[uploadId].iconKeys.forEach(function (iconId) {
                        state[uploadId].icons[iconId].selected = false;
                    });
                }
            }));
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.FEATURE_COLLECTION:
            if (state.keys) {
                nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                    if (state[uploadId].status === "active") {
                        state[uploadId].iconKeys.forEach(function (iconId) {
                            state[uploadId].icons[iconId].feature_collection = true;
                        });
                    }
                }));
            }
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.UNFEATURE_COLLECTION:
            if (state.keys) {
                nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                    if (state[uploadId].status === "active") {
                        state[uploadId].iconKeys.forEach(function (iconId) {
                            state[uploadId].icons[iconId].feature_collection = false;
                        });
                    }
                }));
            }
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.APPROVE_ICONS:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                if (state[uploadId].status === "active") {
                    state[uploadId].result = action.type;
                }
            }));
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.APPROVE_ICONS_SUCCESS:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                if (state[uploadId].status === "active") {
                    state[uploadId].iconKeys.forEach(function (iconId) {
                        action.response.uploads.forEach(function (approvedIcon) {
                            if (iconId === approvedIcon.id) {
                                state[uploadId].icon_count = state[uploadId].icon_count - 1;
                                var i = state[uploadId].icons[iconId];
                                i.status = "approved";
                                i.selected = false;
                            }
                        });
                    });
                    state[uploadId].result = action.type;
                }
            }));
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.DENY_ICONS:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                if (state[uploadId].status === "active") {
                    state[uploadId].result = action.type;
                }
            }));
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.DENY_ICONS_SUCCESS:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                if (state[uploadId].status === "active") {
                    state[uploadId].iconKeys.forEach(function (iconId) {
                        action.response.uploads.forEach(function (deniedIcon) {
                            if (iconId === deniedIcon.id) {
                                state[uploadId].icon_count = state[uploadId].icon_count - 1;
                                var i = state[uploadId].icons[iconId];
                                i.status = "denied";
                                i.selected = false;
                            }
                        });
                    });
                    state[uploadId].result = action.type;
                }
            }));
            nextState.result = action.type;
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SAVE_NAME:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                var i = state[uploadId].icons[action.icon_id];
                i.name = action.name;
            }));
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SAVE_TAGS:
            nextState = Object.assign({}, state, state.keys.forEach(function (uploadId) {
                var i = state[uploadId].icons[action.icon_id];
                i.tags = action.tags;
            }));
            return Object.assign({}, state, nextState);
            break;

        case actionTypes.SUSPEND_CREATOR_SUCCESS:
            // return empty upload object as we fetch next batch
            return {};
            break;

        default:
            return state;
            break;
    }
};

var mergeEntity = function mergeEntity(type, id, state, newObj) {
    var arrays = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    if (state) {
        arrays.union.forEach(function (a) {
            if (newObj[a] && state[a]) {
                newObj[a] = (0, _union2.default)(state[a], newObj[a]);
            }
        });
        arrays.replace.forEach(function (a) {
            if (newObj[a] && state[a]) {
                state[a] = newObj[a];
            }
        });
        newObj = Object.assign({}, state[id], newObj);
    }

    return Object.assign({}, state, newObj);
};